<template>
  <v-container fluid>
    <search-view :show-search-options="true"
                 :search-options="getSearchKeys"
                 :show-search-date-options="false"
                 :show-search-date="true"
                 :show-add-button="true"
                 @addEvent="addEvent"
                 @initEvent="searchEvent"
                 @searchEvent="searchEvent"
                 @reset="reset"></search-view>

    <v-layout>
      <v-radio-group
          v-model="status"
          row
      >
        <v-radio
            label="未開立"
            :value="0"
            :color="Theme.GREEN"
        ></v-radio>
        <v-radio
            label="已開立"
            :value="1"
            :color="Theme.GREEN"
        ></v-radio>
      </v-radio-group>
    </v-layout>

    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <InvoiceDetail :visible="paymentView.visible" @cancelEvent="paymentView.visible = false"
                   @confirmEvent="reset"/>
  </v-container>
</template>

<script>
import SearchView from "@/components/SearchView";
import TableView from "@/components/TableView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import InvoiceDetail from "@/pages/invoice/InvoiceDetail.vue";
export default {
  name: "Index",
  components: {
    InvoiceDetail,
    TableView, SearchView
  },
  mixins: [common],
  data() {
    return {
      status: 0,
      loading: false,
      searchKey:'',
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
      paymentView: {
        visible: false,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
      startDate: '',
      endDate: '',
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters(['getUserInfo']),
    getColumnKeys(){
      return [
        // { value:'ok', text:'確認付款' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        // { value:'print', text:'出貨單', color: this.Theme.GREEN, sortable: false , isEvent: true },
        { value:'RelateNumber', text:'訂單編號', sortable: true },
        { value:'CustomerEmail', text:'Email', sortable: true , },
        { value:'ItemName', text:'品項', sortable: true , },
        { value:'SalesAmount', text:'金額', sortable: true , },
        { value:'createdDate', text:'建立日期', sortable: true },
        { value:'InvoiceNo', text:'發票號碼', sortable: false },
        { value:'CustomerIdentifier', text:'統編', sortable: true },
        { value:'CustomerName', text:'抬頭', sortable: true },
        { value:'status', text:'發票狀態', options:[{key: 0, value: '未開立' , color: this.Theme.PaymentStatus.YELLOW, dark: false },
            {key: 1, value: '已開立' , color: this.Theme.PaymentStatus.GREEN, dark: false },
          ]},
      ]
    },
    getSearchKeys() {
      return [
        { key: "InvoiceNo", value: "發票號碼" },
        { key: "CustomerEmail", value: "Email" },
      ];
    },
  },
  methods: {
    ...mapActions(['getInvoiceList', 'savePaymentInfo']),
    async loadData(){
      if (!this.isAdmin && !this.isStaff) return;
      try {
        let searchQuery = [];
        if (this.searchKey !== '' && this.searchValue !==''){
          searchQuery.push({ key:this.searchKey , value: this.searchValue });
        }

        this.loading = true;
        const res = await this.getInvoiceList({
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          searchQuery: searchQuery,
        });

        if (res.data.statusCode === 0){
          this.list = res.data.data.list;
          this.pagination.totalItems = res.data.data.header.totalCount;

          console.log(`getInvoiceList ${JSON.stringify(this.list)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getInvoiceList error`, e.stack);
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1){
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'ok'){
        // this.showAlert({
        //   title: '提示',
        //   content: '是否確定此訂單已付款？',
        //   confirmEvent: async () => {
        //     this.hideAlert();
        //     await this.saveEvent(cell.item);
        //   }
        // });
      } else if (cell.key === 'delete'){
        // this.showAlert({
        //   title: '提示',
        //   content: '是否確定要刪除此商品？',
        //   confirmEvent: async () => {
        //     this.hideAlert();
        //     await this.deleteEvent(cell.item);
        //   }
        // });
      } else {
        this.editView.title = cell.key === 'add' ? '新增訂單':'修改訂單'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    // async saveEvent(payment){
    //   try {
    //     const res = await this.savePaymentInfo({
    //       status: '00',
    //       orderId: payment.MerchantTradeNo,
    //     });
    //     const result = res.data;
    //     if (result && result.statusCode === 0){
    //       this.showAlert({title: '提示',
    //         content: result.message,
    //         confirmEvent: async () => {
    //           this.hideAlert();
    //         }});
    //     } else {
    //       this.showAlert({title: '提示',
    //         content: `儲存失敗 ${result.message}`,
    //         confirmEvent: async () => {
    //           this.hideAlert();
    //         }});
    //     }
    //
    //   } catch (e) {
    //     console.log(`儲存失敗`)
    //   }
    // },
    addEvent(){
      this.paymentView.visible = true;
    },
    searchEvent(info){
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      this.loadData();
    },
    reset(){
      this.paymentView.visible = false;
      this.searchValue = '';
      this.loadData();
    },
  }
}
</script>

<style scoped>

</style>
